import script from "./fclty-mber-mng.vue?vue&type=script&setup=true&lang=js"
export * from "./fclty-mber-mng.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__